import { render, staticRenderFns } from "./CompetitionEditAssessors.vue?vue&type=template&id=c91da84a&"
import script from "./CompetitionEditAssessors.vue?vue&type=script&lang=js&"
export * from "./CompetitionEditAssessors.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports